import React from 'react'

import SelectProjectMulti from "../../../../app/quick-add/sections/view/components/forms/common-blocks/project-multi"
import FormManager from "../../../gd-form/common/form-manager"
import CustomView from "../../../model2/custom-view/custom-view"
import SelectUsersMulti from "../../../../app/quick-add/sections/view/components/forms/common-blocks/users-multi"
import quickAdd_getUsersIds from "../../../../app/quick-add/sections/view/components/forms/functions/get-users-ids"
import SelectOptionMulti
    from "../../../../app/quick-add/sections/view/components/forms/common-blocks/select-option-multi"
import {SHOW_DEADLINE, SHOW_START_END} from "../../../../views/pastdue/constants"
import getAvailableProjectsByViewType from "../../functions/get-available-projects"
import {EntityType} from "../../../gd/const/item";

type PastdueConditionsType = {
    projects            : ID[]
    users               : ID[]
    pastdueItems        : {
        projects    : boolean
        tasks       : boolean
        events      : boolean
    }
    pastdueTypes        : {
        deadline    : boolean
        endDate     : boolean
    }
}

type Props = {
    className?  : string

    view        : CustomView
    disabled?   : boolean
    onChange    : { (conditions: PastdueConditionsType):void }
}

// const debug = "ViewPastDue_Conditions"
const debug = false

export default function ViewPastDue_Conditions(props: Props) {

    debug && console.log(debug, 'render', props)

    const onUserChange = () => {
        debug && console.log(debug, 'onUserChange')

        const result = form.getValues()

        const pastdueItems = {
            projects    : result.pastdueItems.includes('projects'),
            tasks       : result.pastdueItems.includes('tasks'),
            events      : result.pastdueItems.includes('events'),
        }

        const pastdueTypes = {
            deadline    : result.pastdueTypes.includes(SHOW_DEADLINE),
            endDate     : result.pastdueTypes.includes(SHOW_START_END),
        }

        const conditions: PastdueConditionsType = {
            projects        : result.projects,
            users           : result.users,
            pastdueItems    : pastdueItems,
            pastdueTypes    : pastdueTypes,
        }

        debug && console.log(debug, 'onUserChange conditions', conditions)

        props.onChange(conditions)
    }

    const updateUsersField = (name: string, allUserIds: ID[]) => {
        const users = form.getValue(name);
        const newUsers = _.intersection(users, allUserIds)
        form.setFieldValue(name, newUsers)
    }

    const onParentSelect = (projects: ID[]) => {
        debug && console.log(debug, 'onParentSelect')

        form.onFormComponentValueChange('projects', projects)
        const newUsers = quickAdd_getUsersIds(projects)

        updateUsersField('users', newUsers)

        onUserChange()
    }

    const conditions = props.view.settings

    const pastdueItems = []
    if (conditions?.pastdueItems?.projects)  pastdueItems.push('projects')
    if (conditions?.pastdueItems?.events)    pastdueItems.push('events')
    if (conditions?.pastdueItems?.tasks)     pastdueItems.push('tasks')

    const pastdueTypes = []
    if (conditions?.pastdueTypes?.deadline)  pastdueTypes.push(SHOW_DEADLINE)
    if (conditions?.pastdueTypes?.endDate)   pastdueTypes.push(SHOW_START_END)

    const initFormData: any = {
        projects        : conditions?.projects || [],
        users           : conditions?.users || [],
        pastdueItems    : !_.isEmpty(pastdueItems) ? pastdueItems : ['projects', 'events', 'tasks'],
        pastdueTypes    : !_.isEmpty(pastdueTypes) ? pastdueTypes : [SHOW_DEADLINE, SHOW_START_END],
    }

    const formStructure = {
        fields          : {
            projects        : { type: 'select',   isRequired: false,  label: 'Projects'},
            users           : { type: 'select',   isRequired: false,  label: 'Users',                   onUserChange: onUserChange},
            pastdueItems    : { type: 'select',   isRequired: false,  label: 'View type',               onUserChange: onUserChange,
                validator: (val: any) => {
                    return val.length > 0 ? true : 'At least one type should be selected'
                }},
            pastdueTypes    : { type: 'select',   isRequired: false,  label: 'Pastdue type',            onUserChange: onUserChange,
                validator: (val: any) => {
                    return val.length > 0 ? true : 'At least one pastdue type should be selected'
                }},
        },
        isFormChanged   : true,
    }

    const form = new FormManager(formStructure, initFormData)
    const projectsIds = form.getValue('projects') || []
    const usersIds = quickAdd_getUsersIds(projectsIds)

    const classes = Classes("ui5-form", props.className)

    const viewItemsOptions = [
        { value: 'projects',    label: 'Projects',  icon: '' },
        { value: 'events',      label: 'Events',    icon: '' },
        { value: 'tasks',       label: 'Tasks',     icon: '' },
    ]

    const pastdueTypeOptions = [
        { label: 'Deadline',    value: SHOW_DEADLINE },
        { label: 'Start - end', value: SHOW_START_END },
    ]

    return (
        <div className={classes}>
            <div className="tbl">
                <SelectProjectMulti form                = {form}
                                    formFieldName       = 'projects'
                                    availableProjects   = {getAvailableProjectsByViewType(props.view.type)}
                                    disabled            = {props.disabled}
                                    parentsFor          = {EntityType.PROJECT}
                                    onParentSelect      = {onParentSelect}/>

                <SelectUsersMulti label                 = "Users"
                                  form                  = {form}
                                  formFieldName         = 'users'
                                  usersIds              = {usersIds}
                                  includeCurrentUser    = {true}
                                  disabled              = {props.disabled}/>

                <SelectOptionMulti label         = "View items"
                                   form          = {form}
                                   formFieldName = 'pastdueItems'
                                   options       = {viewItemsOptions}
                                   disabled      = {props.disabled}/>

                <SelectOptionMulti label         = "Pastdue type"
                                   form          = {form}
                                   formFieldName = 'pastdueTypes'
                                   options       = {pastdueTypeOptions}
                                   disabled      = {props.disabled}/>
            </div>
        </div>
    )
}
